export enum ProjectTag {
    UnopenedByPartner = 'UNOPENED_BY_PARTNER'
}
